<button (click)="showFavorites()">Favorites</button>&nbsp;&nbsp;
<button (click)="addEditFavorite()">Save as favorite</button>&nbsp;&nbsp;

<app-modal-basic #modalFavorites id="modalFavorites">
  <div class="app-modal-header modal-padding">
    <h6 class="modal-title">Saved favorite reports</h6>
  </div>
  <div class="app-modal-body modal-padding">
    <ag-grid-angular style="width: 100%; height: 370px;"
                     class="ag-theme-fresh"
                     id="gridSavedReports"
                     [gridOptions]="gridOptions">
    </ag-grid-angular>
  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-default btn-modal" (click)="modalFavorites.hide()">Close</button>
  </div>
</app-modal-basic>

<app-modal-basic #modalAddEdit>
  <div class="app-modal-header modal-padding">
    <h6 class="modal-title">Save as favorite report</h6>
  </div>
  <div class="app-modal-body modal-padding">
    <table style="width:100%">
      <tr id="validationMsg" style="display: none">
        <td style="padding-bottom: 5px; color: red; white-space: pre-wrap" id="validationErrorTd" colspan="4">
          Fields marked with * cannot be blank
        </td>
      </tr>
      <tr>
        <td>
          Report type
        </td>
        <td>
          <select class="form-control" [(ngModel)]="reportTypeNoSaveAs" >
            <option value="1">Giving</option>
            <option value="2">Development</option>
            <option value="3">Pledges</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          Report name *
        </td>
        <td>
          <input id="ReportName" type="text" [(ngModel)]="gridFilter.reportName" maxlength="95" class="form-control" trimOnBlur data-not-blank>
        </td>
      </tr>
    </table>
  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-primary btn-modal" (click)="saveAddEditReportFavorite()">Save</button>
    &nbsp;
    <button type="button" class="btn btn-default btn-modal" (click)="cancelAddEditReportFavorite()">Cancel</button>
  </div>
</app-modal-basic>
